import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export type UtmParameterType = 'source' | 'medium' | 'campaign' | 'term' | 'content';

export class UtmValidator {
    public static source(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }

            const validPattern = /^[a-zA-Z0-9._-]+$/;

            return validPattern.test(control.value)
                ? null
                : { utmSource: { value: control.value } };
        };
    }
}
